<template>
  <div>
    <div class="list-title">
      <h3>Permisos</h3>
    </div>

    <div class="search-bar">
      <v-container fluid class="pa-0">
        <v-layout row wrap>
          <v-flex xs12 md3>
            <v-text-field class="lance" v-model="search" label="Nombre" @input="searchOnTable"></v-text-field>
          </v-flex>
          <v-spacer></v-spacer>
          <v-btn fab v-if="credentials.roleCreate" color="primary" @click="goTo('roleform')">
            <v-icon dark>add</v-icon>
          </v-btn>
        </v-layout>
      </v-container>
    </div>

    <v-data-table
      :headers="headers"
      :items="list"
      :loading="loading"
      class="table-catalog elevation-5">
      <v-progress-linear slot="progress" color="primary" indeterminate></v-progress-linear>
      <template slot="items" slot-scope="props" @click="goTo('roleform/' + props.item.id)">
        <tr v-bind:class="{ itemToDelete: props.item.id === itemToDelete }"
          class="cursor-pointer"
          @click="credentials.roleRead? goTo('roledetail/' + props.item.id): null">
          <td class="text-xs-left">{{ props.item.name }}</td>
          <td class="text-xs-left">{{ props.item.description }}</td>
          <td class="text-xs-right">
            <v-btn fab small color="primary" 
              v-if="credentials.roleUpdate" 
              @click.stop="goTo('roleform/' + props.item.id)">
              <img src="@/assets/icon-editar.svg" alt="">
            </v-btn>
            <v-btn fab small color="error" 
              v-if="credentials.roleDelete" 
              @click.stop="confirmDelete(props.item.id)">
              <img src="@/assets/icon-eliminar.svg" alt="">
            </v-btn>
          </td>
        </tr>
      </template>
      <template slot="no-data">
        No hay registros para sus parámetros de búsqueda. Favor de intentar otra búsqueda o crear uno nuevo.      
      </template>
    </v-data-table>

    <v-dialog v-model="deleteDialog" max-width="350">
      <v-card>
        <v-card-title class="headline">Confirmación</v-card-title>
        <v-card-text>¿Está seguro de querer borrar este registro?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" flat @click="deleteDialog=false; itemToDelete = '';">Cancelar</v-btn>
          <v-btn color="primary" flat @click="deleteDialog=false; deleteRegistry(itemToDelete)">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>


<script>
  import { events } from '../main';
  import _ from 'underscore';
  import moment from 'moment-timezone';

  export default {
    data () {
      return {
        list: [],
        source: [],
        search: '',
        headers: [
          { text: 'Nombre', value: 'name' },
          { text: 'Descripción', value: 'description' },
          { text: '', value: 'delete', align: 'center' },
        ],
        loading: true,
        deleteDialog: false,
        itemToDelete: '',
        credentials: JSON.parse(localStorage.getItem('userCredentials')),
      }
    },
    methods: {
      snackbar: function(message) {
        events.$emit('snackbar', message);            
      },
      confirmDelete: function(id) {
        this.itemToDelete = id;
        this.deleteDialog = true;
      },
      goTo(url) {
        const self = this;
        self.$router.push('/' + url);
      },
      getList: function() {
        this.$http.get('role')
          .then(response => {
            const list = response.body;
            this.list = list;
            this.source = list;
            this.loading = false;
          }, error => {
            let message = error.body.msg || 'Hubo un problema al obtener la lista';
            this.snackbar(message);
            console.error(error);
          });
      },
      deleteRegistry(id) {
        this.showConfirm = false;
        this.$http.delete('role/' + id)
          .then(response => {
            this.itemToDelete = '';
            this.getList();
            this.snackbar('El registro ha sido eliminado con éxito');
          }, error => {
            this.itemToDelete = '';
            let message = error.body.msg || 'Hubo un problema al eliminar el registro';
            this.snackbar(message);
            console.error(error);
          });
      },
      searchOnTable: function() {
        const self = this;
        this.list = _.filter(this.source, function(item) {
          return 1 === 2
            || item.name.toLowerCase().includes(self.search.toLowerCase())
        });
      },
    },
    mounted() {
      this.getList();
    },
    filters: {
      moment: function (date) {
        return moment(date).locale('es').format('LL');
      }
    }
  }
</script>